import { types } from "util";

export const locale = {
  lang: 'en',
  data: {
    MENU: {
      DASHBOARD: {
        COLLAPSIBLE: "Dashboard",
        BADGE: "2",
        ANALYTICS: "Analytics",
        ECOMMERCE: "E-Commerce",
        "users": "Users",
        "list": "List",
        "add": "Add",
              "MISSED_PRAYERS": "Missed Prayers"
,    "Details": "Details"
,  "NOTIFICATIONS_LIST": "Notifications List",
      "ID": "ID",
        "SOCIAL_LINKS_LIST": "Social Links List",
      "ON_BOARDING_LIST": "On Boarding List",
  "SHOW": "Show",
  "ENTRIES": "Entries",
    "LESSONS": "Lessons",
 "religious_inquiries": "Religious Inquiries",
      "IMAGE": "Image",
            "religious_inquiries_list": "Religious Inquiries List",
      "TITLE": "Title",
      "DESCRIPTION": "Description",
      "ORDER": "Order",
      "MISSED_FASTING": "Missed Fasting",
"REMAINING_DAYS": "Remaining Days",
"REASON": "Reason",
"PENDING": "Pending",
      "DATE": "Date",
      "READ": "Read",
      "errorLogin": "Invalid email or password. Please try again.",
        "ENABLED": "Enabled",
      "DISABLED": "Disabled",
      "USER_DETAILS": "User Details",
      "NAME": "Name",
      "EMAIL": "Email",
       "DAILY_USERS_LIST": "Daily Users List",
      "PRAYER_MAKEUP_LIST": "Prayer Make-Up List",
      "PARTICIPATION_ENGAGEMENT_LIST": "Participation & Engagement List",
      "ZAKAT_LIST": "Zakat List",
      "RAMADAN_MISSED_FASTS_LIST": "Missed Ramadan Fasts List",
      "FATWA_LIST": "Fatwa List",
      "FIQH_LIST": "Fiqh List",
      "ASK_MUFTI_LIST": "Ask the Mufti List",
      "categories_list": "Categories List",
      "CITY": "City",
       "daily_users": "Daily Users",
      "prayer_makeup": "Prayer Makeup",
      "participation_engagement": "Participation and Engagement",
      "zakat": "Zakat",
      "ramadan_missed": "Ramadan Missed",
      "fatwa": "Fatwa",
      "fiqh": "Fiqh",
      "ask_mufti": "Ask the Mufti",
      "items": "Items",
      "items_list": "Items List",
       "NEW_USERS": "New Users",
      "NEW_USERS_TODAY": "New Users Today",
      "TOTAL_ELIMINATION": "Total Eliminations",
      "TOTAL_ELIMINATION_TODAY": "Eliminations Today",
      "COUNTRY": "Country",
  
      "PRIVACY_POLICY": "Privacy Policy",
"NOTIFICATIONSs": {
    "ADD": "Add Notification",
    "EDIT": "Edit Notification",
  
  },
 "WELCOME_MESSAGE": "Welcome Back 👋",
      "TOTAL_USERS": "Total Users",
      "Select_User": "Select a user",
           "PROGRESS": "Progress",

      "Type": "Type",
      "Read": "Read",
      "Unread": "Unread",
      "Save_Changes": "Save Changes",
      "MONTHS": "Missed Months",
      "TOTAL_DAYS": "Total Days",
      "COMPLETED": "Completed",
      "DETAILS": "Details",
            "ADD_SOCIAL_LINK": "Add Social Link"
,
      "Description": "Description",
      "AddOnBoarding": "Add OnBoarding"
,
        "Link": "Link",
      "Platform": "Platform",
      "CREATED_AT": "Created At",
       "TITLEE": "Introduction Screens",
      "LIST_TITLEE": "Introduction Screens List",
      "NO": "No",
      "CHANGE_LANGUAGE": {
      "LABEL": "Change Language",},
      "PRIVACY_POLICY_LIST": "Privacy Policy List",
 "AUTH": {
    "LOGIN": {
      "TITLE": "Wadhakkir",
      "SUBTITLE": "Please sign-in to your account and start the adventure",
      "EMAIL": "Email",
      "EMAIL_PLACEHOLDER": "Enter your email",
      "EMAIL_REQUIRED": "Email is required",
      "EMAIL_INVALID": "Email must be a valid email address",
      "PASSWORD": "Password",
      "PASSWORD_REQUIRED": "Password is required",
      "SIGN_IN": "Sign in",
      "CHANGE_LANG_EN": "English",
      "CHANGE_LANG_AR": "Arabic"
    }
  },
  "User_ID": "User ID",
      "Title": "Title",
      "Message": "Message",
      "name_ar": "Name (Arabic)",
      "name_en": "Name (English)",
      "Image": "Image",
      "Add": "Add",
            "Select_Platform": "Select platform"
,
      
      "UPDATED_AT": "Updated At",
      "YES": "Yes",
      "UNREAD": "Unread",
      "SAVE": "Save",
            "EDIT_SOCIAL_LINKS": "Edit Social Links",

      "MISSED_PRAYERS_TODAY": "Missed Prayers Today",
      "CANCEL": "Cancel",
       "EDIT": "Edit",
      "DELETE": "Delete",
      "ACTIONS": "Actions",
        "ads": "Ads",
        "counselors": "Counselors",
        "stores_offers": "Stores Offers",
        "cancelation_reason": "Cancelation Reason",
        "companies": "Companies",
        "consulting": "Consulting",
        "categories": "Categories",
        "services": "Services",
        "tags": "Tags",
        "NOTIFICATIONS": "Notifications",
      "SOCIAL_LINKS": "Social Links",
      "ON_BOARDING": "On Boarding",
        "articles": "Articles",
        "offers": "Offers", 
        "USERS_LIST": "Users List",
      "SEARCH": "Search",
      "MISSED_PRAYERS_LIST": "Missed Prayers List", 
        "plantcards": "Plant Cards",
"Active": "Active",
    "Expired": "Expired",
        "Settings": "Settings",
        "ShowDetails": "Show Details",
        "TermsAndConditions": "Terms & Conditions",
        "About": "About",
        "Notifications": "Notifications",
        "Currencies": "Currencies",
        "Countries": "Countries",
        "Cities": "Cities",
        "plans": "plans",
      "light": "light",
      "root": "root",
      "seed": "seed",
      "soil": "soil",
      "stem": "stem",
      "counselorspayment": "counselorspayment",
      "OpenScreens": "Open Screens",
      "GanatakCommunity": "Ganatak Community",
      "Paperform": "Paperform",
      "Sizes": "Sizes",
      "Sliders": "Sliders"
      },
      USERS_SECTION: "Customers",
      USERS: {
        LIST: "Users List",
        ADD: "Add User"
      },
      PRODUCTS: {
        Title: "Products",
        LIST: "Products List",
        AT_HOME: "Products at Home"
      },
      COUNSELORS: {
        Title: "Consultants",
        LIST: "Consultants List",
        ADD: "Add Consultant"
      },
      STORES: {
        Title: "Stores",
        LIST: "Stores List",
        ADD: "Add Store"
      },
      STORES_OFFERS: {
        Title: "Store Offers",
        LIST: "Offers List"
      },
      VOUCHER: {
        Title: "Promotions",
        TYPE: "Promotion Types",
        LIST: "Promotions List"
      },
      cancelation_reasons: {
        Title: "Cancellation Reason",
        LIST: "Cancellation Reasons List",
        ADD: "Add Reason"
      },
      COMPANIES: {
        Title: "Companies",
        LIST: "Companies List",
        ARCHIVED: "Archived Companies",
        ADD: "Add Company"
      },
      consulting: {
        Title: "Consulting",
        LIST: "Consulting List",
      },
      SERVICES: {
        Title: "Services",
        LIST: "Services List",
        ADD: "Add Service"
      },
      SECTION: {
        Title: "Sections",
        LIST: "Sections List",
        TYPES: "Voucher Types",
        ADD: "Add Section"
      },
      ARTICLES: {
        Title: "Articles",
        LIST: "Articles List",
        Plant_groups: "Plant Groups",
        ADD: "Add",
        various: "Various Agricultural Articles",
      },
      TAGS: {
        Title: "Tags",
        LIST: "Tags List",
        ADD: "Add Tag"
      },
      offers: {
        Title: "Offers",
        LIST: "Offers List",
        ADD: "Add Offers"
      },
      reasone_canceled: {
        Title: "Cancellation Reason",
        LIST: "List",
        ADD: "Add"
      },
      PLANTCARDS: {
        TITLE: "Plant Cards",
        LIST: "Plant Cards List",
        ADD: "Add Plant Card",
        LEAVERSCOLOR: {
          TITLE: "Leaf Colors",
          LIST: "Leaf Colors List",
          ADD: "Add Leaf Color"
        },
        LEAVERSFORM: {
          TITLE: "Leaf Shapes",
          LIST: "Leaf Shapes List",
          ADD: "Add Leaf Shape"
        },
        FLOWERFORM: {
          TITLE: "Flower Shapes",
          LIST: "Flower Shapes List",
          ADD: "Add Flower Shape"
        },
        FLOWERCOLOR: {
          TITLE: "Flower Colors",
          LIST: "Flower Colors List",
          ADD: "Add Flower Color"
        },
        ENVIRONMENTLIGHT: {
          TITLE: "Environmental Light",
          LIST: "Environmental Light List",
          ADD: "Add Environmental Light"
        },
        ENVIRONMENTTEMP: {
          TITLE: "Environmental Temperature",
          LIST: "Environmental Temperature List",
          ADD: "Add Environmental Temperature"
        },
        ENVIRONMENHUMIDITY: {
          TITLE: "Environmental Humidity",
          LIST: "Environmental Humidity List",
          ADD: "Add Environmental Humidity"
        },
        REPRODUCTIONS: {
          TITLE: "Reproduction",
          LIST: "Reproduction Methods List",
          ADD: "Add Reproduction Method"
        },
        PLANTCARDSOIL: {
          TITLE: "Soil Types",
          LIST: "Soil Types List",
          ADD: "Add Soil Type"
        },
        
      }
        
    }
  }


}
